module.exports = __webpack_public_path__ + "static/img/3_1.3c69a530.jpg";